import React, { useState } from 'react';
import { PaymentSummaryItems } from '../../../components/lakeview/payment/PaymentSummaryItems';
import ConfirmModal from '../../../components/modal/ConfirmModal';
import PaymentTransactionFormConfig from '../../transactions/PaymentTransactionFormConfig';
import Form from '../../../components/form/Form';
import { format } from 'date-fns';
import { Actions } from '../../../../client/Actions';
import CustomCard from '../../../components/CustomCard';
import { renderPaymentStatus } from '../../../helpers/renders/paymentStatusMapping';
import { formatDateWithShortDay } from '../../house-offer/result/HouseOfferAmountTableConfig';
import PaymentSummary from '../checkout/PaymentSummary';

export const ReservationPaymentSummary = ({ reservation, reloadData }) => {
  const [paymentModal, setPaymentModal] = useState({
    show: false,
    amount: null,
    ready: false,
    label: '',
    transactionType: 'PAYMENT' // default PAYMENT
  });

  if (!reservation) {
    return null;
  }

  const handleAction = (amount, label, transactionType = 'PAYMENT') => {
    setPaymentModal({
      show: true,
      amount: amount,
      label: label,
      transactionType: transactionType
    });
  };

  const dailyItems = reservation.dailyAmounts?.map((daily) => ({
    label: `${formatDateWithShortDay(daily.date)} x ${daily.coefficient}`,
    amount: daily.amount
  }));

  const items = [

    {
      label: 'Zapłacono',
      amount: reservation.paidAmount,
      borderBottom: true
    },
    {
      label: 'Wpłacono kaucji',
      amount: reservation.paidDeposit,
      borderBottom: true,
      show: reservation.paidDeposit || reservation.paymentSummary?.securityDepositAmount
    },
    {
      label: 'Pozostało do zapłaty',
      amount: reservation.remainingAmount,
      bold: true,
      borderBottom: true,
      show: !(reservation.remainingToRefund > 0)
    },
    {
      label: 'Pozostało do zapłaty kaucji',
      amount: reservation.remainingDeposit,
      bold: true,
      borderBottom: true,
      show: !(reservation.securityDepositToRefund > 0)
    },
    {
      label: 'Razem do zwrotu',
      amount: reservation.remainingToRefund,
      show: reservation.remainingToRefund > 0,
      bold: true,
      borderBottom: !(reservation.securityDepositToRefund > 0)

    },
    {
      label: 'Kaucja do zwrotu',
      amount: reservation.securityDepositToRefund,
      show: reservation.securityDepositToRefund > 0,
      bold: true,
    },
  ];

  const toPay = [
    {
      amount: reservation.remainingToPayOnBooking,
      label: 'Pozostało do zapłaty przy rezerwacji',
      show:
        reservation.remainingToPayOnBooking > 0 &&
        reservation.remainingToPayOnBooking !== reservation.remainingAmount,
      onPay: () =>
        handleAction(
          reservation.remainingToPayOnBooking,
          'Pozostało do zapłaty przy rezerwacji',
          'PAYMENT'
        )
    },
    {
      amount: reservation.remainingToPayOnCheckin,
      label: 'Pozostało do zapłaty przy zameldowaniu',
      show:
        reservation.remainingToPayOnCheckin > 0 &&
        reservation.remainingToPayOnCheckin !== reservation.remainingAmount,
      onPay: () =>
        handleAction(
          reservation.remainingToPayOnCheckin,
          'Pozostało do zapłaty przy zameldowaniu',
          'PAYMENT'
        )
    },
    {
      amount: reservation.remainingAmount,
      label: 'Pozostało do zapłaty',
      show: reservation.remainingAmount > 0,
      onPay: () =>
        handleAction(
          reservation.remainingAmount,
          'Pozostało do zapłaty',
          'PAYMENT'
        )
    },
    {
      amount: reservation.remainingDeposit,
      label: 'Pozostało do zapłaty kaucji',
      show: reservation.remainingDeposit > 0,
      onPay: () =>
        handleAction(
          reservation.remainingDeposit,
          'Pozostało do zapłaty kaucji',
          'DEPOSIT_PAYMENT'
        )
    },
    {
      amount: reservation.remainingToRefund,
      label: 'Dostępne do zwrotu',
      show: reservation.remainingToRefund > 0,
      onPay: () =>
        handleAction(
          reservation.remainingToRefund,
          'Zwrot płatności',
          'REFUND'
        )
    },
    {
      amount: reservation.securityDepositToRefund,
      label: 'Dostępne do zwrotu kaucji',
      show: reservation.securityDepositToRefund > 0,
      onPay: () =>
        handleAction(
          reservation.securityDepositToRefund,
          'Zwrot kaucji',
          'DEPOSIT_REFUND'
        )
    }
  ];

  return (
    <CustomCard
      title={
        <dic className={'d-flex align-items-center gap-2'}>
          <span>Podsumowanie płatności </span>
          {renderPaymentStatus(
            reservation.paymentStatus,
            'p-2 ms-2',
            true,
            true
          )}{' '}
        </dic>
      }
      className={'sticky-top top-160'}
    >
      <PaymentSummary
        paymentSummary={reservation.paymentSummary}
        nights={reservation.nights}
        readOnly={true}
      />
      <PaymentSummaryItems items={items} toPay={toPay} />

      {paymentModal.show && (
        <ConfirmModal
          show={paymentModal.show}
          setShow={(show) => setPaymentModal((prev) => ({ ...prev, show }))}
          size="md"
          ready={paymentModal.ready}
          title={`${paymentModal.transactionType === 'REFUND' ? 'Zwrot' : 'Zapłać'} - ${paymentModal.label}`}
          onConfirm={() => {
            paymentModal.data.reservationId = reservation.id;
            Actions.post('payment-transaction', paymentModal.data, reloadData);
          }}
          form={
            <Form
              initialData={{
                amount: paymentModal.amount,
                transactionType: paymentModal.transactionType,
                paymentType: reservation.paymentTypeOnBooking || reservation.paymentTypeOnCheckin,
                paymentDate: format(new Date(), 'yyyy-MM-dd')
              }}
              noActions={true}
              onReadyUpdate={(ready) =>
                setPaymentModal((prev) => ({ ...prev, ready }))
              }
              formDataChanged={(data) =>
                setPaymentModal((prev) => ({ ...prev, data }))
              }
              fields={PaymentTransactionFormConfig}
            />
          }
        />
      )}
    </CustomCard>
  );
};

export default ReservationPaymentSummary;
